<button class="close" mat-button (click)="closeDialog()">X</button>
<div mat-dialog-title>
  <h5 *ngIf="header"><strong>{{header}}</strong></h5>
</div>
<div mat-dialog-content>
  <div>
    <em>{{message}}</em>
  </div>
</div>
